import { useSelector } from "react-redux";
import {
  useDeleteReportMutation,
  useGetReportListDataQuery,
  useUpdateReportTableHeadDataMutation,
} from "../../../store/queries/Master";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
// import { updateConfig } from "../../../store/slices/Master/Source/sourceSlice";
import { updateConfig } from "../../../store/slices/Master/Report/reportSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { approveReportRequest, getReportData } from "./api";
import { Button, Image } from "@wac-ui-dashboard/wac_component_library";

const useReport = () => {
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];

  const dispatch = useDispatch();

  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const reportState = useSelector((state) => state.report);
  const {
    data: reportList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetReportListDataQuery({
    page_size: reportState?.currentPageSize,
    page: reportState?.currentPage,
    sort_by: reportState?.sortBy,
    sort_order: reportState?.sortOrder,
    start: reportState?.startDate,
    end: reportState?.endDate,
    search: reportState?.search,
  });

  const [deleteReport] = useDeleteReportMutation();
  const [updateReportFields] = useUpdateReportTableHeadDataMutation();
  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = reportList?.data?.fields;
      })
    );
    // eslint-disable-next-line
  }, [reportList]);

  useEffect(() => {
    if (reportState?.selectedReport && reportState?.isEdit) {
      fillReportData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportState?.isEdit, reportState?.showAddReportModal]);
  useEffect(() => {
    if (reportState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [reportState.clearSelection]);

  const handleModalClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showAddReportModal = !state.showAddReportModal;
        state.isEdit = false;
        state.reportData = [];
      })
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      status: (field, data) =>
        data?.status === "Pending" && reportList?.data?.approve_permission ? (
          <Button
            className={"pro-btn-primary sm"}
            type="button"
            onClick={() => handleApprovePermission(data?._id)}
          >
            {"Approve"}
          </Button>
        ) : data?.status === "Deleted" ? (
          <span className={"pro-badge badge-danger-outline"}>{"Deleted"}</span>
        ) : data?.status === "Active" ? (
          <span className={"pro-badge badge-success-outline"}>{"Active"}</span>
        ) : (
          data?.status
        ),
      back_image: (field, data) => (
        <Image
          width={50}
          height={50}
          src={data[field]}
          alt={field}
          className="pro-img-fluid"
        />
      ),
    };

    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };
  const handleApprovePermission = (approveId) => {
    let params = {
      report_id: approveId,
    };
    approveReportRequest(params).then((response) => {
      if (response?.data?.status_code === 200) {
        refetch();
        toast.success("Approved successfully");
      } else {
        toast.error("Something went wrong");
      }
    });
  };
  const handleDelete = () => {
    deleteReport(reportState?.selectedReport).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Report deleted successfully");
        handleDeleteModal();
        refetch();
      } else {
        toast.error("Something went wrong");
        handleDeleteModal();
      }
    });
  };

  const fillReportData = () => {
    getReportData(reportState?.selectedReport).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig((state) => (state.ReportData = response?.data?.data))
        );
      } else {
        toast.error("Something went wrong to fetch report data");
      }
    });
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedReport = e?.[0];
      })
    );
  };

  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showAddReportModal = true;
        state.selectedReport = e?.[0];
        state.isEdit = true;
      })
    );
  };

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handleSort = (label) => {
    if (reportState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = reportState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };
  return {
    reportState,
    showEditModal,
    tableFields,
    reportList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    updateReportFields,
    handleClearClick,
    handlePageSize,
    refetch,
  };
};

export default useReport;
